import { Component } from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {MessageService} from "primeng/api";
import {MagazzinoService} from "../../../../services/magazzino.service";
import {CompoMovimentazione} from "../stato-movimentazioni.component";

@Component({
  selector: 'app-movimentazione-annullamento-dialog',
  templateUrl: './movimentazione-annullamento-dialog.component.html',
  styleUrls: ['./movimentazione-annullamento-dialog.component.scss']
})
export class MovimentazioneAnnullamentoDialogComponent {

	srcMov: CompoMovimentazione;

	constructor (
		public ref: DynamicDialogRef,
		public config: DynamicDialogConfig<{
			movimentazione: CompoMovimentazione
		}>,
		private messages: MessageService,
		private backendMagazzino: MagazzinoService
	) {
		console.log("cancel dialog for ", this.config.data.movimentazione);
		this.srcMov = this.config.data.movimentazione;
	}

	onActivityCompleted (confirm: boolean) {
		this.ref.close(confirm ? { requestRevertMov: true }: null);
	}
}
